import React, { useEffect, useState, useCallback } from "react";
import { Container } from "@mui/system";
import Logo from "../../assets/img/logo-reenergisa.png";
import { Grid, Card, Box, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';
import CustomLoading from "../../components/CustomLoading";
import userLogged from "../../services/userLogged";
import api from "../../services/api";
import storage from "../../services/storage";
import { getUserDetails } from "../../services/graphService";
import { msalConfig, loginRequest } from "../../services/azureADNew";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import logo from "./../../assets/img/logo.png";
import {
  useMsal,
  useIsAuthenticated,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import './styles.css';

const LoginPage = () => {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const inLogout = urlParams.get('inLogout')

  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();

  const [showModal, setShowModal] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [autenticatedConclude, setAutenticatedConclude] = useState(false);
  const [authenticatedData, setAuthenticatedData] = useState(null);

  function signInClickHandler() {
    instance.loginRedirect();
  }

  function SignInButton() {
    return (
      <Button variant="contained" className="color-white bg-color-primary" startIcon={<img src={logo} className="logo-button-image" alt="Usuario Energisa" />} onClick={() => signInClickHandler()}>
        Energisa
      </Button>
    )
  }

  function SignInButtonTerceiros() {
    return (
      <Button variant="contained" className="color-white bg-color-primary" startIcon={<PeopleAltIcon />} onClick={() => window.location = "/login-terceiros"}>
        Outros
      </Button>
    )
  }

  function signOutClickHandler() {

    userLogged.removeUserLoggedData();

    storage.removeAwsValidation();
    storage.removeAzureAdValidation();

    const logoutRequest = {
      account: instance.getAccountByHomeId(msalConfig.auth.clientId),
      mainWindowRedirectUri: "/",
      postLogoutRedirectUri: "/",
    };
    instance.logoutRedirect(logoutRequest);
  }

  function SignOutButton() {
    return (
      <Button variant="contained" className="color-white bg-color-secoundary" onClick={() => signOutClickHandler()}>
        Sair
      </Button>
    );
  }

  const requestAccessToken = useCallback(() => {
    setShowModal(true);

    const request = {
      ...loginRequest,
      account: accounts[0]
    };

    if (inLogout === null) {
      instance.acquireTokenSilent(request).then((response) => {
        userLogged.setApiAccessToken(response.accessToken);
        setAccessToken(response.accessToken);
        setRedirect(true);
      }).catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          userLogged.setApiAccessToken(response.accessToken);
          setAccessToken(response.accessToken);
          setRedirect(true);
        });
      });
    }

    setShowModal(false);
  }, [accounts, instance, inLogout]);

  useEffect(() => {
    setShowModal(true);

    if (accessToken !== null && isAuthenticated) {
      getUserDetails(accessToken).then(response => {
        console.info('User AzureAD authenticated:', response.displayName);

        userLogged.setApiAccessToken(accessToken);
        storage.setApiAccessToken(accessToken);
        setAutenticatedConclude(true);
        setAuthenticatedData(response);
      });
    }
    setShowModal(false);
  }, [accessToken, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      requestAccessToken();
    }
  }, [isAuthenticated, requestAccessToken]);

  useEffect(() => {
    if (autenticatedConclude && accessToken != null) {

      if (authenticatedData.displayName !== null && authenticatedData.companyName) {
        setShowModal(true);

        console.info('Request to validate authentication.');

        if(accessToken !== null){
          storage.setApiAccessToken(accessToken);
        }

        api.init.post('').then((response) => {
          //Variables from AWS validation
          storage.setAwsValidation(response.data.token, response.data.email, response.data.permissao);

          //Variables from AzureAd validation
          storage.setAzureAdValidation(authenticatedData.displayName, authenticatedData.companyName);

          if (redirect && accessToken !== null && inLogout === null) {
            setTimeout(() => {
              window.location = "pages/home";
            }, 1000);
          }
          setShowModal(false);
        })
          .catch((execption) => {
            setShowModal(false);
          });
      }
    }
  }, [autenticatedConclude, accessToken, authenticatedData, redirect, inLogout]);

  useEffect(() => {
    if (inLogout !== undefined) {
      storage.removeAll();
      localStorage.clear();
    }
  }, [inLogout])

  return (
    <>
      <CustomLoading show={showModal} />

      <Container maxWidth="sm" className="text-center margin-top-50px">
        <Grid container direction="row" justifyContent="center" alignItems="center" mt={2} className="text-center padding-30px-15px">
          <Grid item lg={8} md={8} sm={6} className="text-center">
            <Card elevation={3} className="text-center padding-20px">
              <Box>
                <img src={Logo} className="width-100px" alt="logo" />
              </Box>
              <CardHeader title="EnergisaDash" subheader="Dashboards." />

              <AuthenticatedTemplate>
                <>
                  <CardContent>
                    <form>
                      <Grid container className="margin-top-25px text-left">
                        <Grid item lg={12} sm={12}>
                          <Typography className="font-size-9-pt color-disabled">
                            Clique no botão "Sair" para realizar logout do EnergisaDash. <br />
                            <br />
                            <br />
                            <br />
                          </Typography>
                        </Grid>
                      </Grid>
                    </form>
                  </CardContent>
                  <CardActions>
                    <Grid container mt={2}>
                      <Grid item lg={12} sm={12} className="text-center">
                        <SignOutButton />
                      </Grid>
                    </Grid>
                  </CardActions>
                </>
              </AuthenticatedTemplate>

              <UnauthenticatedTemplate>
                <>
                  <CardContent>
                    <form>
                      <Grid container className="margin-top-25px text-left">
                        <Grid item lg={12} sm={12}>
                          <Typography className="font-size-9-pt color-disabled">
                            Escolha o modo de acesso para realizar login e acessar o EnergisaDash. <br />
                          </Typography>
                          <Grid container mt={2}>
                            <Grid item lg={6} sm={6} className="text-right padding-10px">
                              <SignInButton />
                            </Grid>
                            <Grid item lg={6} sm={6} className="text-right padding-10px">
                              <SignInButtonTerceiros />
                            </Grid>
                          </Grid>
                          <br />
                          <br />
                          <Typography className="font-size-9-pt color-disabled">
                            Não sabe qual é seu usuário? <br />
                          </Typography>
                          <br />
                          <Typography className="font-size-9-pt color-disabled">
                            <b>Usuário Energisa:</b> informe suas credenciais de rede.<br />
                            <b>Outros usuários:</b> informe suas credenciais do EnergisaDash.<br />
                          </Typography>
                        </Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </>
              </UnauthenticatedTemplate>

            </Card>

            <Grid container mt={1}>
              <Grid item lg={12} sm={6} className="text-right padding-10px">
                <Button className="color-disabled">Ajuda</Button>
                <Button className="color-disabled">Privacidade</Button>
                <Button className="color-disabled">Termos</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>

    </>
  );
}

export default LoginPage;